'use strict';

require('../typography.cjs');
var typography$1 = require('../../../../../../../../../_virtual/typography2.cjs');

var typography = typography$1.__exports;

typography.TYPOGRAPHY_TYPES.h2;
//# sourceMappingURL=titles.cjs.map
